import { Box, Container, createTheme, CssBaseline, Grid, TextField, ThemeProvider, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { getOneInByClave, getOneInByReferencia } from "../../services/crudCustom";
import { WaitDialog } from "../modules/dialogs/WaitDialog";
import ApplicationBar from "../modules/ui/ApplicationBar";
import QRCode from 'qrcode';
import { Footer } from "../modules/ui/Footer";
import moment from "moment";


export const VisualizarRegistro = () => {
    // Hook que obtiene los parametros que se envian por la url
    let params = useParams();
    const { ref } = params;

    // state para cargar info
    const [isLoading, setIsLoading] = useState(false);

    // state para los valores del formulario
    const [formValues, setFormValues] = useState({ 
        partApellidoPaterno: "",
        partApellidoMaterno: "",
        partNombres: "",
    });

    // state para los valores del evento
    const [event, setEvent] = useState({ });

    // state para los pares key-value de los encabezados de las tablas
    const [items, setItems] = useState([ ]);
    
    // state para el QR
    const [sourceQR, setSourceQR] = useState({ qrdata: "" });
    

    useEffect(() => {
        document.title = "Visualizar registro CIBNOR";

        const loadInitialData = async () => {

            // Obtenemos el proyecto de la referencia bancaria
            const numProy = ref.substring(0, 5);
            // Recuperamos el evento
            const resultProyDataLoaded = await getOneInByClave({ table:'EventosConRegistro', clave:numProy });

            console.log(resultProyDataLoaded);

            var ProyData = {};
            var resultUserDataLoaded = {};
            // Si exito === 1 es un congreso, taller, etc.
            if (resultProyDataLoaded.exito === 1) {
                ProyData = resultProyDataLoaded.data[0];
                setEvent({ ...ProyData });

                // Recuperamos el registro
                if (ProyData.claveProyecto.startsWith("0")) {
                    resultUserDataLoaded = await getOneInByReferencia({ table:'RegistroGeneral', referencia:ref });

                } else {
                    resultUserDataLoaded = await getOneInByReferencia({ table:ProyData.tabla, referencia:ref });
                }

            } else {
                // ... en caso contrario, puede ser que sea un educon
                resultUserDataLoaded = await getOneInByReferencia({ table:'RegistrosEducon', referencia:ref });

                setEvent({
                    tituloEvento: 'Dirección de Posgrado | EduCon',
                    // urlLogo: 'https://eventos.cibnor.mx/registro/educon/images/logo_posgradoCib.png',
                })
            }
            
            console.log({ resultUserDataLoaded });


            // Aqui ya debemos tener los datos del participante, independiente del registro en el que se inscribieron
            if (resultUserDataLoaded.exito === 1) {
                // Obtenemos el registro
                const dataLoaded = resultUserDataLoaded.data[0];
                console.log(dataLoaded);
                setFormValues(dataLoaded);

                // Arreglamos los encabezados a mostrar
                let items = [];
                let itemsKeys = Object.keys(dataLoaded);
                let itemsValues = Object.values(dataLoaded);;

                for (let index = 0; index < itemsKeys.length; index++) {

                    // Si es una fecha, formatear 'DD MMMM YYYY'
                    if ( itemsKeys[index] === 'fechaRegistro' || itemsKeys[index] === 'fechaPago' ) {
                        if (itemsValues[index] !== null) {
                            
                            itemsValues[index] = moment( itemsValues[index] ).format('DD MMMM YYYY');
                        }
                    }

                    // --- Los dos campos del comprobante, convertirlos a uno solo
                    if ( itemsKeys[index] === 'compPagoURLLabel' ) {
                        items.push({ 
                            key : itemsValues[index], 
                            value : itemsValues[index+1]
                        });
                        continue;
                    }
                    if ( itemsKeys[index] === 'compPagoURL' ) {
                        continue;
                    }
                    // --- 

                    if ( dataLoaded.factExtranjero === 'true') {
                        // Es extranjero, omite requiereFactura
                        if ( itemsKeys[index] === 'requiereFactura' ) { 
                            console.log("aqui");
                            continue; 
                        }
                    } 
                    else {
                        // Es nacional, omite factExtranjero
                        if ( itemsKeys[index] === 'factExtranjero' ) { continue; }
                    }

                    /* --- Esto solo aplica a los eventos EDUCON */


                    if ( 
                        itemsKeys[index] === 'infoAdicional' 
                        || itemsKeys[index] === 'datosAdicionales' 
                        || itemsKeys[index] === 'registroClaveProyecto' 
                    ) {
                        continue;
                    }
                    if ( itemsKeys[index] === 'tipoRegistroDocURL' ) {
                        console.log(itemsKeys[index]);
                        console.log(itemsValues[index]);
                        items.push({ 
                            key : 'Documento probatorio', 
                            value : itemsValues[index] 
                        });
                        continue;
                    }

                    
                    /* --- EOF: Esto solo aplica a los eventos EDUCON */

                    /* --- Esto solo aplica a los eventos que no son EDUCON */

                    // Ejecuta este bloque si el evento es el de la SIMAC
                    if (
                        ProyData.claveProyecto === "74622" ||
                        ProyData.claveProyecto === "20493"
                    ) {
                        // En el item -trabajos-
                        if ( itemsKeys[index] === 'trabajos') { 
                            // Si es ponente, gestiona los trabajos
                            if (dataLoaded.tipoRegistro === 'Ponente' || dataLoaded.tipoRegistro === 'Ponente_online') {
                                const trabajosArray = JSON.parse(itemsValues[index])
                                console.log({trabajosArray});
                                trabajosArray.forEach( trab => {
                                    items.push({
                                        key : trab.trabTitulo,
                                        value : trab.trabResumenURL
                                    });
                                });
                            }
                            // En cualquier caso, descarta el item -trabajos-
                            continue;
                        }
                    }
                    // EOF: bloque si el evento es el de la SIMAC
                    
                    /* EOF: --- Esto solo aplica a los eventos que no son EDUCON */

                    // Agregar a items el par valor a mostrar
                    items.push({ 
                        key : itemsKeys[index].replace(/([a-z])([A-Z])/g, '$1 $2').toUpperCase().replace('PART ', ''), 
                        value : itemsValues[index] 
                    });
                }

                
                console.log({items});
                // Seteamos los items que se mostraran en pantalla
                setItems(items);

                // Generamos el QR para mostrar
                const qrString = `${process.env.REACT_APP_HOMEPAGE}/visualizar-registro/${dataLoaded.registroReferencia}`;
                console.log(qrString);

                QRCode.toDataURL( qrString )
                .then( (data) => {
                    setSourceQR( { qrdata:data } ); 
                })
                
            } else {
                Swal.fire({
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    title: "No existe el registro.",
                    text: `La referencia ${ref} es invalida.`,
                    footer: `Dudas o aclaraciones: ${ProyData.correoEvento}`, // "Por favor, comuniquese al correo electrónico del evento.",
                    showConfirmButton: false,
                    icon: 'error',
                });
            }

        }
        setIsLoading(true);
        loadInitialData();
        setIsLoading(false);
        
    }, [ ref ])

    return (
        <ThemeProvider theme={createTheme()}>
            <Container component="main" maxWidth="md">
            <CssBaseline />
                <Box
                    sx={{
                        mt: 6,
                        mb: 8,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <ApplicationBar 
                        title={ event.tituloEvento } 
                        subtitle={`Datos de registro de ${formValues.partNombres} ${formValues.partApellidoPaterno} ${formValues.partApellidoMaterno} `} 
                        logo={ event.urlLogo } 
                        logoVariant='square'
                    />
                    {/* QR */}
                    { (formValues.compPagoFecha !== '') ? 
                        <Grid item xs={12} sx={{ textAlign:'center' }} >
                            <img src={ sourceQR.qrdata } alt="QR" width={ 200 } />
                        </Grid>
                    : ''}
                    
                    {/* Contenedor general */}
                    <Grid
                        container
                        maxWidth={window.innerWidth}
                        spacing={2}
                        sx={{ pt: 2, pb: 3 }}
                    >

                        {items.map(({ key, value }) => (
                            // Excluye los que tienen como valor 'null' o '', y los siguientes campos...                            
                            ((value !== null) && (value !== '') &&
                                !(  [
                                        "ID", 
                                        "CLAVE PROY REC",
                                    ].includes(key) )
                            ) &&
                            ( 
                                // Es un URL? usa su key como label del link
                                (value.startsWith("http")) ?
                                (<Grid item xs={12} key={ key }>
                                    <Typography>
                                        <a href={ value } target="_blank" rel="noreferrer" >{ key }</a>
                                    </Typography>
                                </Grid>) 
                                :
                                (<Grid item xs={12} key={ key }>
                                    <TextField
                                        // Si value es diferente a true o false...
                                        value={( 
                                            (value !== 'true' && value !== 'false') ? value 
                                            : ( 
                                                ((value === 'false') && 'No' ) ||
                                                ((value === 'true') && 'Si' )
                                                ) 
                                        )}
                                        fullWidth
                                        variant="standard"
                                        size="small"
                                        label={ key }
                                        InputProps={{ readOnly: true, }}
                                    />
                                </Grid>)
                            )
                        ))}

                    </Grid>
                    {/* Footer */}
                    <Footer />
                </Box>
            </Container>
            {/* Dialogo de cargando info */}
            <WaitDialog show={isLoading} />
        </ThemeProvider>
    );
};
